import src from "IMAGE";
export default { src, width: 320, height: 62, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABocHVUPERM1ExgcTzMfEUdhLw5cUygNS1otEFZMSkiTAD4zLpQgJiuBIiowj2Y7II6YSReWfj0UdoA+FHcqGQ8zxvUPnOygMowAAAAASUVORK5CYII="};
